module.exports = __webpack_public_path__ + "img/M7.a21686fc.jpg";